<template>
    <section class="table">
        <div class="box">
        <div class="table__header">
            <h1>{{title}}</h1>
            <div class="btns">
                <router-link v-if="hasPermission('Libraries', 'insert')" class="btn" :to="{ name: 'libraryForm', params: { action: 'create' } }">
                    <i class="fal fa-plus-circle"></i>
                </router-link>
            </div>
        </div>
        <div class="table__content">


            <div class="searchInput">
                <div class="searchInput__inner">
                    <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Cerca"
                            single-line
                            hide-details
                    ></v-text-field>
                </div>
            </div>


            <v-data-table
                :headers="headers"
                :items="libraries"
                :search="search"
                class="elementTable"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
            >
                <template v-slot:items="props">
                    <td>{{props.item.library}}</td>
                    <td>{{props.item.supplier}}</td>
                    <td v-html="'<div class=\'p-10\'>' +props.item.description + '</div>'"></td>
                    <td>{{props.item.translation}}</td>
                    <td class="action" v-if="canEditOrDelete">
                        <div class="actions">
                            <router-link v-if="hasPermission('Libraries', 'edit')" class="button icon btn_success" :to="{ name: 'libraryForm', params: { id: props.item.id, action: 'edit' } }">
                                <i class="fal fa-edit"></i>
                            </router-link>
                            <a class="button icon btn_danger" v-if="hasPermission('Libraries', 'delete')" @click.stop="nameSelected = props.item.library; idSelected = props.item.id; dialog = true">
                                <i class="fal fa-trash-alt"></i>
                            </a>
                        </div>
                    </td>
                </template>
            </v-data-table>
        </div>
        </div>


        <!-- MODALE LIBRARYFORM -->
        <div v-if="dialog" class="modal-overlay" @click.self="dialog = false">
            <div class="modal modal-confirm">

                <!-- HEADER -->
                <div class="modal-header">
                    <span class="headline">Sei sicuro?</span>
                    <button class="close-btn" @click="dialog = false">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
                <!-- BODY -->
                <div class="modal-body">
                    <div style="margin-bottom: 20px">L'elemento <strong>{{ nameSelected }}</strong> verrà eliminato e non potrà essere ripristinato</div>
                    <div class="flex-gap">
                        <button class="button button-p" @click="idSelected = null; dialog = false">Annulla</button>
                        <button class="button button-p" @click="deleteProject(idSelected); dialog = false">Ok cancella</button>
                    </div>
                </div>
            </div>
        </div>


    </section>
</template>
<script>

    import { mapGetters } from 'vuex'

    export default {
        name: 'listLibrary',
        
        data () {
            return {
                title: 'Librerie',
                dialog: false,
                idSelected: null,
                nameSelected: null,
                search: '',
                rowsPerPageItems: [20, 40, 60, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
                pagination: {
                    rowsPerPage: 20
                },
                headers: [
                    { text: 'Nome', align: 'left', value: 'library' },
                    { text: 'Fornitore', align: 'left', value: 'supplier' },
                    { text: 'Descrizione', align: 'left', value: 'description', sortable: false },
                    { text: 'Tipologia', align: 'left', value: 'translation' },
                    { text: '', sortable: false }
                ]
            }
        },
        computed: {
            ...mapGetters('librariesModule', ['libraries']),
            ...mapGetters(['hasPermission']),
            canEditOrDelete() {
                return this.hasPermission('Libraries', 'edit') || this.hasPermission('Libraries', 'delete');
            },
        },

        methods: {
            loadLibraries () {
                this.$store.dispatch('librariesModule/loadLibraries', {urlToConnect: 'libraries'})
            },
            deleteLibrary(id){
                var parameters = {
                    urlToConnect: 'libraries/' + id,
                    methodToConnect: 'delete',
                    _method: "delete"
                }
                this.idSelected = null;
                this.nameSelected = null;
                this.$store.dispatch('librariesModule/deleteLibrary', parameters)
            }
        },
        watch: {
            '$route' () {
                this.loadLibraries()
            }
        },
        created () {
            this.loadLibraries()
            this.$store.dispatch('librariesModule/resetLibrary')
        }


    }
</script>